module.exports = new __parcel__URL__("boards-directory-app-skeleton.tpl.e4de30a4.svg").toString();